import { Pipe, PipeTransform } from '@angular/core';
import { ApiMailHelperService } from './mail-helper.service';
import { ucFirst } from '../helpers/function/uc-first';

@Pipe({
  name: 'apiMail',
})
export class ApiMailHelperPipe implements PipeTransform {
  constructor(private _apiMailHelperSrv: ApiMailHelperService) {}

  transform(railGuard: any, ...args: any[]): any {
    const [fct] = args;
    args.shift();
    return (this._apiMailHelperSrv as any)['get' + ucFirst(fct)](
      railGuard,
      ...args
    );
  }
}

@Pipe({
  name: 'apiMailU',
  pure: false,
})
export class ApiMailHelperUnpurePipe
  extends ApiMailHelperPipe
  implements PipeTransform {}
